document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.slider2');
  const arrows = document.querySelectorAll('.arrow2');
  const lines = [];

  let currentIndex = 0;
  let slidesToShow = window.innerWidth >= 600 ? 3 : 1; // Initially show 3 slides on desktop, 1 on mobile

  function updateSlidesToShow() {
    slidesToShow = window.innerWidth >= 600 ? 3 : 1; // Adjust based on your responsive needs
    showSlide(currentIndex);
  }

  function showSlide(index) {
    const translateValue = -index * (100 / slidesToShow);
    slider.style.transform = `translateX(${translateValue}%)`;

    // Highlight active line
    lines.forEach((line, i) => {
      line.classList.toggle('active', i === index);
    });
  }

  function createLines() {
    for (let i = 0; i < slider.children.length; i++) {
      const line = document.createElement('div');
      line.classList.add('line2');
      lines.push(line);
      document.querySelector('.line-container2').appendChild(line);
    }
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % slider.children.length;
    showSlide(currentIndex);
  }

  function prevSlide() {
    currentIndex = (currentIndex - 1 + slider.children.length) % slider.children.length;
    showSlide(currentIndex);
  }

  arrows.forEach((arrow) => {
    arrow.addEventListener('click', () => {
      if (arrow.classList.contains('left2')) {
        prevSlide();
      } else if (arrow.classList.contains('right2')) {
        nextSlide();
      }
    });
  });

  // Update slides to show on window resize
  window.addEventListener('resize', updateSlidesToShow);

  // Initial setup
  createLines();
  updateSlidesToShow();
});

// document.addEventListener('DOMContentLoaded', function () {
//   const slider = document.querySelector('.slider2');
//   const arrows = document.querySelectorAll('.arrow2');
//   const lines = [];

//   let currentIndex = 0;

//   function showSlide(index) {
//     const translateValue = -index * 100; // Adjust based on the width of each slide item
//     slider.style.transform = `translateX(${translateValue}%)`;

//     // Highlight active line
//     lines.forEach((line, i) => {
//       line.classList.toggle('active', i === index);
//     });
//   }

//   function createLines() {
//     for (let i = 0; i < slider.children.length; i++) {
//       const line = document.createElement('div');
//       line.classList.add('line2');
//       lines.push(line);
//       document.querySelector('.line-container2').appendChild(line);
//     }
//   }

//   function nextSlide() {
//     currentIndex = (currentIndex + 1) % slider.children.length;
//     showSlide(currentIndex);
//   }

//   function prevSlide() {
//     currentIndex = (currentIndex - 1 + slider.children.length) % slider.children.length;
//     showSlide(currentIndex);
//   }

//   arrows.forEach((arrow) => {
//     arrow.addEventListener('click', () => {
//       if (arrow.classList.contains('left2')) {
//         prevSlide();
//       } else if (arrow.classList.contains('right2')) {
//         nextSlide();
//       }
//     });
//   });


//   // Wait for the next frame to ensure the correct rendering
//   requestAnimationFrame(() => {
//     // Create lines and show initial slide
//     createLines();
//     showSlide(currentIndex);
//   });
// });
// document.addEventListener('DOMContentLoaded', function () {
//     const slider = document.querySelector('.slider2');
//     const arrows = document.querySelectorAll('.arrow2');
//     const lines = [];

//     let currentIndex = 0;

//     function showSlide(index) {
//         const translateValue = -index * 33.33; // Adjust based on the width of each slide item
//         slider.style.transform = `translateX(${translateValue}%)`;

//         // Highlight active line
//         lines.forEach((line, i) => {
//             line.classList.toggle('active', i === index);
//         });
//     }

//     function createLines() {
//         for (let i = 0; i < slider.children.length; i++) {
//             const line = document.createElement('div');
//             line.classList.add('line2');
//             lines.push(line);
//             document.querySelector('.line-container2').appendChild(line);
//         }
//     }

//     function nextSlide() {
//         currentIndex = (currentIndex + 1) % slider.children.length;
//         showSlide(currentIndex);
//     }

//     function prevSlide() {
//         currentIndex = (currentIndex - 1 + slider.children.length) % slider.children.length;
//         showSlide(currentIndex);
//     }

//     arrows.forEach((arrow) => {
//         arrow.addEventListener('click', () => {
//             // Your existing logic for arrow clicks
//             if (arrow.classList.contains('left2') || arrow.classList.contains('right2')) {
//                 const container = arrow.closest('.navigation-container2');
//                 const isLeft = arrow.classList.contains('left2');

//                 if (isLeft) {
//                     prevSlide();
//                 } else {
//                     nextSlide();
//                 }
//             }
//         });
//     });

//     // Wait for the next frame to ensure the correct rendering
//     requestAnimationFrame(() => {
//         // Create lines and show the initial slide
//         createLines();
//         showSlide(currentIndex);
//     });
// });
